// extracted by mini-css-extract-plugin
export default {"container":"CarouselDropzone-module__container--pju1V","label":"CarouselDropzone-module__label--Uw0jc"};